@if (isOpen) {
    <div class="workflow-modal" role="dialog" aria-modal="true">
      <div class="workflow-modal__backdrop" (click)="close()"></div>
    
      <!-- Modal Card -->
      <div
        class="workflow-modal__card relative z-10 bg-white rounded-2xl shadow-2xl w-full max-w-[560px] mx-4 animate-modal-in overflow-hidden"
        (click)="$event.stopPropagation()"
      >
        <!-- Close Button -->
        <button
          (click)="close()"
          class="absolute top-4 right-4 w-8 h-8 bg-red-500 hover:bg-red-600 active:scale-95 transition-all duration-150 rounded-lg flex items-center justify-center shadow-md z-20"
          aria-label="Close modal"
        >
          <svg
            class="w-4 h-4 text-white"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
    
        <!-- Scrollable Body -->
        <div class="overflow-y-auto max-h-[90vh] px-8 pt-8 pb-6">
          <!-- Header -->
          <div class="mb-6">
            <h2
              class="text-[1.6rem] font-bold text-gray-800 tracking-tight leading-tight"
            >
              {{ 
                (mode === "APPROVE" && "Approve Existing Application") ||
                (mode === "QUERY" && "Query Existing Application") 
              }}
            </h2>
            <p class="text-sm text-gray-400 mt-0.5 font-medium">
              {{
                (mode === "APPROVE" && "Submit approval for an application") ||
                (mode === "QUERY" && "Submit query for an applications")
              }}
            </p>
          </div>
    
          <!-- Form -->
          <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
            <div class="mb-12 space-y-6">
                <div>
                    <div class="flex items-end justify-between gap-3">
                        <div class="grow flex flex-col gap-1">
                        <label class="text-xs font-semibold text-gray-600 tracking-wide uppercase">Payment Amount</label>
                        <input
                            formControlName="paymentAmount"
                            type="text"
                            placeholder="Enter Payment Amount"
                            class="w-full border border-gray-200 rounded-lg px-3.5 py-2.5 text-sm text-gray-700 placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-400/50 focus:border-teal-400 transition-all duration-200 bg-gray-50/60 disabled:cursor-not-allowed"
                        >
                        </div>
                        
                        @if (modifiedPaymentAmount) {
                            <!-- Remove Payment Amount Button -->
                            <button
                                [disabled]="isSubmitting"
                                type="button"
                                (click)="exitPaymentAmountModification()"
                                class="px-3 py-2 flex items-center gap-2 border border-gray-500 text-gray-500 hover:text-red-400 hover:!border-red-400 rounded-lg transition-colors duration-150"
                                aria-label="Remove step"
                            >
                                <svg
                                    class="size-4"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M6 18L18 6M6 6l12 12"
                                    />
                                </svg>
                                <p>Reset</p>
                            </button>
                        } @else {
                            <!-- Edit Payment Amount Button -->
                            <button
                                [disabled]="isSubmitting"
                                type="button"
                                (click)="modifyPaymentAmount()"
                                class="px-3 py-2 flex items-center gap-2 border border-gray-500 text-gray-500 hover:text-vms-bg-secondary hover:!border-vms-bg-secondary rounded-lg transition-colors duration-150"
                                aria-label="Remove step"
                            >
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" class="size-4">
                                    <g clip-path="url(#clip0_22_3501)">
                                        <path d="M7.49997 2.50019L9.49997 4.50019M10.587 3.40619C10.8513 3.1419 10.9999 2.78342 10.9999 2.40962C11 2.03581 10.8515 1.6773 10.5872 1.41294C10.3229 1.14859 9.96445 1.00005 9.59064 1C9.21684 0.999953 8.85832 1.1484 8.59397 1.41269L1.92097 8.08719C1.80488 8.20294 1.71902 8.34546 1.67097 8.50219L1.01047 10.6782C0.997545 10.7214 0.996569 10.7674 1.00764 10.8111C1.01872 10.8549 1.04143 10.8948 1.07337 10.9267C1.1053 10.9586 1.14528 10.9812 1.18905 10.9922C1.23282 11.0032 1.27875 11.0022 1.32197 10.9892L3.49847 10.3292C3.65505 10.2816 3.79755 10.1962 3.91347 10.0807L10.587 3.40619Z" stroke-linecap="round" stroke-linejoin="round"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_22_3501">
                                            <rect width="12" height="12" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                                <p>Edit</p>
                            </button>
                        }
                    </div>
                    @if (form.controls['paymentAmount']?.errors?.['required']) {
                        <small class="text-xs text-red-500">Payment amount is required.</small>
                    }
                </div>
    
                <div class="md:col-span-2 flex flex-col gap-1">
                    <label class="text-xs font-semibold text-gray-600 tracking-wide uppercase">Comment</label>
                    <textarea 
                      [appCharLength]
                      formControlName="comment"
                      placeholder="Enter Comment"
                      rows="8"
                      class="w-full border border-gray-200 rounded-lg px-3.5 py-2.5 text-sm text-gray-700 placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-400/50 focus:border-teal-400 transition-all duration-200 bg-gray-50/60 disabled:cursor-not-allowed">
                    </textarea>
                </div>
            </div>
    
            <!-- Submit Button -->
            <button
                [disabled]="isSubmitting"
                type="submit"
                class="w-full mt-2 page-btn page-btn-primary active:scale-[0.99] font-semibold text-sm py-3.5 transition-all duration-200"
            >
              Submit
              <svg
                class="size-4"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M13 7l5 5-5 5M6 12h12"
                />
              </svg>
            </button>
          </form>
        </div>
      </div>
    </div>
}

